import cx from 'classnames';
import React, { useState } from 'react';

import './styles/TableRow.scss';

export type Props = {
  active?: boolean;
  children: React.ReactNode;
  className?: string;
  hoverable?: boolean;
  tooltip?: string | null;
} & React.HTMLProps<HTMLTableRowElement>;

export default function TableRow({
  active,
  children,
  className,
  hoverable,
  tooltip,
  ...others
}: Props) {
  const [hovered, setHovered] = useState(false);
  const onMouseEnter = () => setHovered(true);
  const onMouseLeave = () => setHovered(false);

  return (
    <tr
      {...others}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-testid="table-row"
      data-test-selector="table-row"
      className={cx(
        'TableRow',
        active && 'TableRow--active',
        hoverable && 'TableRow--hoverable',
        className
      )}
    >
      {children}
      {hovered && tooltip && (
        <td className={cx('TooltipContainer')}>
          <div className={cx('Tooltip')}>{tooltip}</div>
        </td>
      )}
    </tr>
  );
}
